// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_LegalBasis3BasicRolandDe = z.object({
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()
        .min(sub(new Date(), { years: 120 }))
        .max(sub(new Date(), { years: 18 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  zip_code: z
    .string()
    .min(1)
    .regex(/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/),
  previous_insurer: z.string().min(1).optional(),
  covering_children: z.boolean(),
  employment_status: z.enum([
    'state_employee',
    'self_employed',
    'retired',
    'employed',
    'unemployed',
    'student',
  ]),
  partner_last_name: z.string().min(1).optional(),
  partner_first_name: z.string().min(1).optional(),
  partner_coverage_type: z.enum(['single', 'spouse', 'partner']),
  legal_insurance_in_last_5y: z.boolean(),
  insurance_was_voided_before: z.boolean().optional(),
  number_of_claims_in_last_5y: z.coerce
    .string()
    .pipe(z.enum(['0', '1', '2', '3']))
    .pipe(z.coerce.number())
    .optional(),
  number_of_years_claims_free: z
    .preprocess((val) => {
      if (val === '' || val === undefined) {
        return undefined
      }
      return Number(val)
    }, z.number().int())
    .optional(),
  previous_contract_cancellation_date: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
})

const Schema_LegalBasis3BasicRolandDe = BaseSchema_LegalBasis3BasicRolandDe.superRefine(
  (values, ctx) => {
    if (
      values['legal_insurance_in_last_5y'] !== undefined &&
      [true].includes(values['legal_insurance_in_last_5y'])
    ) {
      if (values['previous_insurer'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['previous_insurer'],
        })
      }
    }
  }
)
  .superRefine((values, ctx) => {
    if (
      values['partner_coverage_type'] !== undefined &&
      ['spouse', 'partner'].includes(values['partner_coverage_type'])
    ) {
      if (values['partner_last_name'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['partner_last_name'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['partner_coverage_type'] !== undefined &&
      ['spouse', 'partner'].includes(values['partner_coverage_type'])
    ) {
      if (values['partner_first_name'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['partner_first_name'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['legal_insurance_in_last_5y'] !== undefined &&
      [true].includes(values['legal_insurance_in_last_5y'])
    ) {
      if (values['insurance_was_voided_before'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'boolean',
          received: 'undefined',
          message: 'Required',
          path: ['insurance_was_voided_before'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['legal_insurance_in_last_5y'] !== undefined &&
      [true].includes(values['legal_insurance_in_last_5y'])
    ) {
      if (values['number_of_claims_in_last_5y'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'integer',
          received: 'undefined',
          message: 'Required',
          path: ['number_of_claims_in_last_5y'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['legal_insurance_in_last_5y'] !== undefined &&
      [true].includes(values['legal_insurance_in_last_5y'])
    ) {
      if (values['number_of_years_claims_free'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'integer',
          received: 'undefined',
          message: 'Required',
          path: ['number_of_years_claims_free'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['legal_insurance_in_last_5y'] !== undefined &&
      [true].includes(values['legal_insurance_in_last_5y'])
    ) {
      if (values['previous_contract_cancellation_date'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'date',
          received: 'undefined',
          message: 'Required',
          path: ['previous_contract_cancellation_date'],
        })
      }
    }
  })

export default Schema_LegalBasis3BasicRolandDe
